import { useLang } from '@/i18n';
import BackToTop from '@elem/compCommon/BackToTop';
import ShopifyCartIcon from '@elem/compCommon/ShopifyCartIcon';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import ShopifyShoppingCart from 'elem/compCommon/ShopifyShoppingCart';
import { ShopifyCartItemType } from 'elem/compCommon/ShopifyShoppingCart/const';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import J from './components/J';
import O from './components/O';
import P from './components/P';
import Q from './components/Q';
import R from './components/R';

export default function IndexDynamic() {
    const [shoppingCarts, setShoppingCarts] = useState([]);
    const [visible, setVisible] = useState(false);
    const { t } = useLang('loadshedding');
    const [isClient, setIsClient] = useState(false);

    const obj: SideMenuProps = {
        items: [
            { text: t('secC_btn1'), link: '#load-shedding-D' },
            { text: t('secC_btn2'), link: '#load-shedding-E' },
            { text: t('secC_btn3'), link: '#load-shedding-F' },
        ],
    };

    const handleAddCart = (card: ShopifyCartItemType) => {
        const obj: ShopifyCartItemType = { ...card };
        const target = shoppingCarts.find((item: ShopifyCartItemType) => item?.productId === card?.productId && item?.variantId === card?.variantId);
        if (target) {
            obj.quantity = target.quantity + (target?.quantity < target.inventory ? 1 : 0);
            // setShoppingCarts([
            //     obj,
            //     ...shoppingCarts?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
            // ]);
            EcoDesignEventsBus.emit('eco-cart-add', [
                obj,
                ...shoppingCarts?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
            ]);
        } else {
            obj.quantity = Number(obj?.inventory) > 0 ? 1 : 0;
            //setShoppingCarts([obj, ...shoppingCarts]);
            EcoDesignEventsBus.emit('eco-cart-add', [obj, ...shoppingCarts]);
        }
        setVisible(true);
    };

    const handleCallback = (carts: ShopifyCartItemType[], isClose?: boolean) => {
        //setShoppingCarts(carts);
        EcoDesignEventsBus.emit('eco-cart-add', carts);
        if (isClose) {
            setVisible(false);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            <B />
            <C tags={obj.items} />
            <F callBuy={handleAddCart} />
            <E callBuy={handleAddCart} />
            <D callBuy={handleAddCart} />
            <J />
            <O />
            <P />
            <Q />
            <R />
            {visible && isClient && createPortal(<ShopifyShoppingCart callback={handleCallback} items={shoppingCarts} />, document.body)}
            {isClient &&
                createPortal(
                    <ShopifyCartIcon
                        quantity={shoppingCarts.reduce((prev: number, curItem: ShopifyCartItemType) => {
                            return prev + Number(curItem.quantity);
                        }, 0)}
                        callback={() => setVisible(true)}
                    />,
                    document.body,
                )}
            {isClient && createPortal(<BackToTop />, document.body)}
            {isClient && createPortal(<SideMenu items={obj.items} />, document.body)}
        </>
    );
}
